<script setup lang="ts">
import InputMask from 'primevue/inputmask';

const props = withDefaults(defineProps<{ usePseudo?: boolean }>(), {
  usePseudo: true,
});

const token = ref<string>('');

const emit = defineEmits<{
  (e: 'valid', token: string): void;
  (e: 'invalid'): void;
}>();

const cleanOtp = (raw: string | null | undefined) =>
  (raw ?? '').replace(/ +/g, '');

const validateOtp = (raw: string | null | undefined): string | null => {
  const otp = cleanOtp(raw);
  if (!otp) return null;
  if (otp.length !== 5) return null;
  if (otp.includes('_')) return null;
  if (!/^\d{5}$/.test(otp)) return null;
  return otp;
};

const handleTokenChange = (raw: string | null | undefined) => {
  const validOtp = validateOtp(raw);
  if (!validOtp) {
    emit('invalid');
    return;
  }
  emit('valid', validOtp);
};

watch(token, (v) => {
  handleTokenChange(v);
});

onMounted(() => {
  if (props.usePseudo) {
    setTimeout(() => {
      const elements = document.getElementsByName('removePseudo');
      [...elements].forEach((el) => el.remove());
    }, 500);
  }
});
</script>

<template>
  <input
    v-if="usePseudo"
    id="username"
    type="email"
    style="opacity: 0; position: absolute"
    name="removePseudo"
  />
  <input
    v-if="usePseudo"
    type="password"
    style="opacity: 0; position: absolute"
    name="removePseudo"
  />

  <InputMask
    v-model="token"
    mask="9   9   9   9   9"
    placeholder="_ _ _ _ _"
    autocomplete="one-time-code"
    class="w-full text-lg cursor-pointer tracking-[8px] text-center"
  />
</template>
